// src/features/tickets/hooks/useTicketAnhangTexte.ts
//
// Lädt den Status der Texterkennung für alle regulären Anhänge eines Tickets
// (TicketDetail). Lädt neu, sobald das Ticket neu geladen wurde, also auch nach
// dem Live-Anstoß, den der ticket-texterkennung-worker nach jedem neuen
// Anhang auslöst.

import { useEffect, useState } from 'react';
import { TicketDetailView } from '../types';
import { ticketAnhangTextService, TicketAnhangTextInfo } from '../services/TicketAnhangTextService';

export const useTicketAnhangTexte = (
  ticket: TicketDetailView | null
): Record<string, TicketAnhangTextInfo> => {
  const [infos, setInfos] = useState<Record<string, TicketAnhangTextInfo>>({});

  useEffect(() => {
    if (!ticket) {
      setInfos({});
      return;
    }

    const ids = ticket.messages.flatMap(m => m.attachments.map(a => a.id));
    if (ids.length === 0) {
      setInfos({});
      return;
    }

    let aktiv = true;
    ticketAnhangTextService.ladeStatus(ids).then(ergebnis => {
      if (aktiv) setInfos(ergebnis);
    });
    return () => {
      aktiv = false;
    };
  }, [ticket]);

  return infos;
};
